export const FEATURE_FLAG_TAILORED_SCHEDULE_AUDITING = "tailored-schedule-auditing"
